<tbody>
  <slot />
</tbody>

<style>
  tbody {
    overflow: auto;
  }
</style>
